export const computeSummary = (items) => {
    const incGross = {}, incNet = {}, expGross = {};
    for (const item of items) {
        if (item.type === 'INCOME') {
            incGross[item.currencyCode] = (incGross[item.currencyCode] ?? 0) + Number(item.gross);
            incNet[item.currencyCode] = (incNet[item.currencyCode] ?? 0) + Number(item.net);
        } else if (item.type === 'EXPENSE') {
            expGross[item.currencyCode] = (expGross[item.currencyCode] ?? 0) + Number(item.gross);
        } else if (item.type === 'TRANSFER') {
            // Money leaving the source currency behaves like an expense.
            expGross[item.currencyCode] = (expGross[item.currencyCode] ?? 0) + Number(item.gross);
            // Money arriving in the destination currency behaves like income.
            // (The transfer loss is implicit in the gap between gross out and transferAmount in.)
            if (item.transferAmount != null && item.transferCurrencyCode) {
                const c = item.transferCurrencyCode;
                incGross[c] = (incGross[c] ?? 0) + Number(item.transferAmount);
                incNet[c] = (incNet[c] ?? 0) + Number(item.transferAmount);
            }
        }
    }
    const currencies = [...new Set([...Object.keys(incGross), ...Object.keys(expGross), ...Object.keys(incNet)])].sort();
    return currencies.map(c => ({
        currency: c,
        income: incGross[c] ?? 0,
        expenses: expGross[c] ?? 0,
        net: incNet[c] ?? 0,
    }));
};

export const computeSummaryForAccounts = (items, accounts) => {
    const incGross = {}, incNet = {}, expGross = {};
    for (const item of items) {
        if (item.type === 'INCOME') {
            incGross[item.accountId] = (incGross[item.accountId] ?? 0) + Number(item.gross);
            incNet[item.accountId] = (incNet[item.accountId] ?? 0) + Number(item.net);
        } else if (item.type === 'EXPENSE') {
            expGross[item.accountId] = (expGross[item.accountId] ?? 0) + Number(item.gross);
        } else if (item.type === 'TRANSFER') {
            // Debit from the source account behaves like an expense.
            expGross[item.accountId] = (expGross[item.accountId] ?? 0) + Number(item.gross);
            // Credit to the destination account behaves like income.
            if (item.transferAmount != null && item.transferAccountId != null) {
                const a = item.transferAccountId;
                incGross[a] = (incGross[a] ?? 0) + Number(item.transferAmount);
                incNet[a] = (incNet[a] ?? 0) + Number(item.transferAmount);
            }
        }
    }

    return accounts.map(account => ({
        accountId: account.id,
        accountTitle: account.title,
        accountSourceName: account.sourceName,
        currency: account.currencyCode,
        income: incGross[account.id] ?? 0,
        expenses: expGross[account.id] ?? 0,
        net: incNet[account.id] ?? 0,
        isEmpty: !incGross[account.id] && !expGross[account.id] && !incNet[account.id],
    }));
};

export const groupByDate = (items) => {
    const map = {};
    for (const item of items) {
        if (!map[item.occurredOn]) map[item.occurredOn] = [];
        map[item.occurredOn].push(item);
    }
    return Object.keys(map)
        .sort((a, b) => b.localeCompare(a))
        .map(date => ({date, items: map[date]}));
};
